import invariant from "invariant";

import { Organization, User } from "../main/graphql";
import { useOptionalCurrentUser } from "../main/hooks/useCurrentUser";
import { checkCookieExistence } from "../utils/cookie";

type AdvancedCustomTemplatesEnabledProps = Pick<
  User,
  "enabledFeatures" | "impersonatedFeatures"
> & {
  organization: Pick<Organization, "allowAiCustomTemplates">;
};

export const useAdvancedCustomTemplatesEnabled = (
  currentUserProp?: AdvancedCustomTemplatesEnabledProps
): boolean => {
  const optionalCurrentUser = useOptionalCurrentUser();
  const currentUser = currentUserProp ?? optionalCurrentUser;
  invariant(currentUser, "Missing current user");

  const { organization, enabledFeatures, impersonatedFeatures } = currentUser;
  const isImpersonating = checkCookieExistence("is_impersonating");

  const flagEnabled = isImpersonating
    ? impersonatedFeatures.includes("custom_templates_v2:launch")
    : enabledFeatures.includes("custom_templates_v2:launch");

  const flagBlacklisted = isImpersonating
    ? impersonatedFeatures.includes("custom_templates_v2:blacklist")
    : enabledFeatures.includes("custom_templates_v2:blacklist");

  const orgSettingEnabled = organization.allowAiCustomTemplates;

  return flagEnabled && orgSettingEnabled && !flagBlacklisted;
};
